import React from 'react';
import { Modal } from '@uberall/zenit';

import styles from './index.module.css';
import Message from '../../../Message';
import { SelectionListItem } from '../../../../contexts/types';
import ModalContent from '../modal-content/modal-content';
import FooterButton from '../footer-button';

type ModalDesktopProps = {
    title: string;
    subtitle: string;
    items: SelectionListItem[];
    isLoading: boolean;
    isFetchingNextPage: boolean;
    onAdd: (items: SelectionListItem[]) => void;
    onClose: () => void;
    onToggle: (id: string) => void;
    fetchNextPage: () => void;
};

const ModalDesktop = ({
    items,
    title,
    subtitle,
    isLoading,
    isFetchingNextPage,
    onAdd,
    onToggle,
    onClose,
    fetchNextPage,
}: ModalDesktopProps) => {
    return (
        <Modal
            className={styles.modal}
            width="large"
            onClose={onClose}
            title={
                <h2 className={styles.modalHeading}>
                    <Message code={title} />
                </h2>
            }
            footer={<FooterButton items={items} onAdd={onAdd} />}
        >
            <ModalContent
                items={items}
                onToggle={onToggle}
                subtitle={subtitle}
                containerClassName={styles.contentContainer}
                fetchNextPage={fetchNextPage}
                isLoading={isLoading}
                isFetchingNextPage={isFetchingNextPage}
            />
        </Modal>
    );
};

export default ModalDesktop;
